export interface IBaseBatchResponse {
  sucesso: boolean;
  mensagem: string;
  status?: string;
  codigo?: number;
}

export interface ICreateBatchConsultResponse {
  id?: number,
  userSub?: string,
  quantity?: number,
  failed?: number,
  message: string,
  success: boolean,
  logConsultsFailed?: any
}

export enum IConsultStatusEnum {
  PAYABLE = "PODE SER PAGA",
  INTEGRATOR_ERROR = "ERRO NO INTEGRADOR",
  IN_PROGRESS = "EM CONSULTA",
  CONSULT_UPDATED = "VERIFIQUE O STATUS DE CADA CONSULTA"
}

export enum IComunixOcurrencyCodeEnum {
  NO_DEBTS_FOUND = '0014-0065',
  VEHICLE_IS_LICENSED = '0014-0186',
  UNSELECTED_SEARCHTYPE = '0014-0186'
}

export interface IConsultStatus {
  identificacao: string;
  codConsulta: number;
  status: IConsultStatusEnum;
  ocorrencia: string;
}

export interface IGetBatchConsultStatusResponse {
  consultas: IConsultStatus[],
  sucesso: boolean
	mensagem: string,
	status: IConsultStatusEnum
}